import WaveButton from "../../../global/WaveButton";

const ListClients = ({clicButtonEdit, addArrayDeleted, clicButtonDeleted, saveClient}) => {

    return (
        <div className="card">
            <div className="card-body">
                <h5 className="card-title font-weight-bold">Lista de Demo</h5>

                <div className="card-content">
                    <div className="row">
                        <div className="col-xl-7 col-lg-6 col-xs-12 mb-2">
                            {/* <input type="text" className="form-control form-control-sm" /> */}
                            <div className="input-group input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1"><i className="mdi mdi-magnify"></i></span>
                                </div>
                                <input type="text" className="form-control" aria-label="Username" aria-describedby="basic-addon1" />
                            </div>

                        </div>
                        <div className="col-xl-3 col-lg-6 col-xs-12 mb-2">
                            <select className="form-control" name="" id="">
                                <option value="">Por 10 registros</option>
                                <option value="">Por 20 registros</option>
                                <option value="">Por 30 registros</option>
                            </select>
                        </div>

                        <div className="col-xl-2 col-lg-6 col-xs-12 mb-2 text-center">
                            <div className="content-buttons btn-group">
                                <WaveButton className="btn btn-default" onClick={saveClient}
                                    content="Actualizar" place="top" dataTooltipId="update-tooltip">
                                    <i className="mdi mdi-refresh"></i>
                                </WaveButton>
                                <WaveButton className="btn btn-danger" onClick={clicButtonDeleted}
                                    content="Eliminar" place="top" dataTooltipId="delete-tooltip">
                                    <i className="mdi mdi-delete"></i>
                                </WaveButton>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-lg-12 col-sm-12 px-2">
                            <table className="table table-striped table-hovered table-fixed mb-0">
                                <tbody className="">
                                    <tr>
                                        <td className="align-middle p-2 w-5 text-center">
                                            <label className="waves-effect waves-light">
                                                <input type="checkbox" name="" id="" onClick={() => addArrayDeleted('1', event.target.checked)} />
                                            </label>
                                          </td>
                                        <td className="align-middle text-justify p-3 w-40">
                                            <span>Dscto Administrativo</span> <br />
                                            <strong><i className="mdi mdi-email"></i> ericklizana12@gmail.com</strong>
                                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas blanditiis reprehenderit sed fugit ad nobis ullam provident incidunt sequi quo dolore enim ab et possimus perferendis, temporibus inventore iure facere.</p>
                                        </td>
                                        <td className="align-middle p-1 w-10 text-center"><span className="badge badge-info badge-pill">Activo</span></td> 
                                        <td className="align-middle p-2 w-10 text-center">
                                            <div className="content-buttons btn-group">
                                                <WaveButton className="btn btn-success btn-sm waves-effect" 
                                                    dataTooltipId="edit-tooltip"  onClick={() => clicButtonEdit('1')} content="Editar un Registro">
                                                    <i className="mdi mdi-pencil-circle"></i>
                                                </WaveButton>      
                                            </div>
                                        </td>
                                    </tr>
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ListClients;